import React, { useState } from 'react'
import { useQueryClient } from 'react-query'
import ModalAddRole from '../../../_metronic/partials/widgets/_new/modal/ModalAddRole'

const RoleManagementRightToolbar = () => {
    const [show, setShow] = useState(false)
    const queryClient = useQueryClient()
    return (
        <div>
            <button
                className='btn btn-sm fw-bold btn-primary'
                onClick={() => { setShow(true) }}
            >
                Add New Role
            </button>
            <ModalAddRole
                show={show}
                setShow={setShow}
                onSuccess={() => queryClient.invalidateQueries(['roles'])}
            />
        </div>
    )
}

export default RoleManagementRightToolbar
